
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/order-history",
      function () {
        return require("private-next-pages/account/order-history/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/order-history"])
      });
    }
  